import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { APIService } from '../shared/service/api.service';
import { FormularioService } from './form.service';
import { ScriptsService } from '../shared/service/scripts.service';

@Component({
  selector: 'app-sugestoes',
  templateUrl: './sugestoes.component.html',
  styleUrls: ['./sugestoes.component.scss'],
})
export class SugestoesComponent implements OnInit {
  formulario: FormGroup;
  localAlteracao: string[];
  camposCurso: { label: string; field: string; checkbox: string }[];
  cursos: {};
  eixos: any;
  resposta: any;
  display: string[] = [];
  regexEmail: RegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  camposAdicionados: string[] = [];
  formErro = false;
  mostarPopUp = false;
  erro = false;

  constructor(
    private api: APIService,
    private formService: FormularioService,
    private scriptsService: ScriptsService,
  ) {
    this.scriptsService.load('reCaptcha');
  }

  ngOnInit(): void {
    const { camposCurso, localAlteracao } = this.formService.getFormFields();
    // console.info('getFormFields', camposCurso);

    this.camposCurso = camposCurso;
    this.localAlteracao = localAlteracao;

    this.api.getEixos().subscribe((resposta) => {
      this.eixos = resposta;
    });

    this.gerarFormulario();

    this.formulario.get('sugestaoPara').valueChanges.subscribe((selecao) => {
      this.verificaSelecaoDaSugestao(selecao);
    });

    this.formulario.get('eixoTecnologicoCnctId').valueChanges.subscribe((eixo) => {
      if (eixo) {
        this.api.getCursosNaoPaginado(eixo).subscribe((curso) => {
          this.cursos = curso;
        });
      }
    });
  }

  gerarFormulario(): void {
    this.formulario = new FormGroup({
      nome: new FormControl(null, Validators.required),
      email: new FormControl(null, [Validators.pattern(this.regexEmail)]),
      instituicaoEmpresa: new FormControl(null),
      sugestaoPara: new FormControl(null, [Validators.required]),
      cursoCnctId: new FormControl(''),
      eixoTecnologicoCnctId: new FormControl(''),
      sugestaoEixo: new FormControl(null),
      sugestaoNavegabilidade: new FormControl(null),
      reCaptcha: new FormControl(null, [Validators.required]),
    });
    // adiciona os campos do formulário relativos ao curso
    this.camposCurso.forEach((campo) => {
      this.formulario.addControl(campo.field, new FormControl(null));
    });
  }

  verificaSelecaoDaSugestao(selecao: string): void {
    if (selecao === 'Eixo Tecnológico') {
      this.adicionaValidadorCampoRequerido(['sugestaoEixo']);
      this.limpaValidadores(['sugestaoNavegabilidade', 'cursoCnctId']);
      this.camposAdicionados = [];
    }

    if (selecao === 'Curso') {
      this.adicionaValidadorCampoRequerido(['eixoTecnologicoCnctId', 'cursoCnctId']);
      this.limpaValidadores(['sugestaoEixo', 'sugestaoNavegabilidade']);
    }

    if (selecao === 'Navegabilidade do site') {
      this.adicionaValidadorCampoRequerido(['sugestaoNavegabilidade']);
      this.limpaValidadores(['eixoTecnologicoCnctId', 'cursoCnctId', 'sugestaoEixo']);
      this.camposAdicionados = [];
    }
  }

  adicionaValidadorCampoRequerido(campos: string[]) {
    campos.forEach((campo) => {
      this.formulario.get(campo).reset();
      this.formulario.controls[campo].setValidators([Validators.required]);
      this.formulario.controls[campo].updateValueAndValidity();
    });
  }

  limpaValidadores(campos: string[]) {
    campos.forEach((campo) => {
      this.formulario.controls[campo].clearValidators();
      this.formulario.controls[campo].updateValueAndValidity();
      this.formulario.get(campo).reset();
    });
  }

  addField(campo: string) {
    if (this.camposAdicionados.includes(campo)) {
      this.camposAdicionados = this.camposAdicionados.filter((el) => el !== campo);
    } else {
      this.camposAdicionados.push(campo);
    }
  }

  validaTodosOsCampos(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((campo) => {
      const controle = formGroup.get(campo);
      if (controle instanceof FormControl) {
        controle.markAllAsTouched();
      } else if (controle instanceof FormGroup) {
        this.validaTodosOsCampos(controle);
      }
    });
    setTimeout(() => {
      this.formErro = false;
    }, 500);
  }

  cancelar() {
    this.formulario.reset();
    this.mostarPopUp = false;
  }

  onSubimitFormulario(): void {
    if (!this.formulario.valid) {
      this.formErro = true;
      this.validaTodosOsCampos(this.formulario);
      return;
    }
    this.camposCurso.forEach((formField) => {
      if (!this.camposAdicionados.includes(formField.checkbox)) {
        this.formulario.get(formField.field).reset();
      }
    });
    const url = window.location.href;
    const form = { ...this.formulario.value, linkFormulario: url };
    this.mostarPopUp = true;
    // return; // remover linha após testes
    this.formService.postForm(form).subscribe(
      (resp) => {
        setTimeout(() => {
          this.resposta = resp;
          this.formulario.reset();
        }, 300);
      },
      (erro) => {
        // console.log(error);
        this.erro = true;
      },
    );
  }
}
